import * as PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { IntlProvider } from 'react-intl';
import { useSelector } from 'react-redux';
import messages from './messages';

const Provider = ({ children }) => {
	const lang = useSelector(state => state.localization.lang);

	return (
		<IntlProvider textComponent={Fragment} locale={lang} messages={messages[lang]}>
			{children}
		</IntlProvider>
	);
};

Provider.displayName = 'I18nProvider';

Provider.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
};

export default Provider;
